Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iconCategories = require('../../utils/iconCategories');

var _makeIcon = require('../../private/makeIcon');

var _makeIcon2 = _interopRequireDefault(_makeIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var StarSvg = function () {
  function StarSvg(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'M971.5 379.5c9 28 2 50-20 67L725.4 618.6l87 280.1c11 39-18 75-54 75-12 0-23-4-33-12l-226.1-172-226.1 172.1c-25 17-59 12-78-12-12-16-15-33-8-51l86-278.1L46.1 446.5c-21-17-28-39-19-67 8-24 29-40 52-40h280.1l87-278.1c7-23 28-39 52-39 25 0 47 17 54 41l87 276.1h280.1c23.2 0 44.2 16 52.2 40z'
      })
    );
  }

  return StarSvg;
}();

StarSvg.componentCategory = 'Core';
StarSvg.displayName = 'StarSvg';
StarSvg.defaultProps = {
  viewBox: '0 0 1000 1000'
};


var IconStar = (0, _makeIcon2['default'])(StarSvg, 'IconStar');
exports['default'] = IconStar;


if (process.env.NODE_ENV !== 'production') {
  IconStar.categories = [_iconCategories.STARS];
}


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/icons/IconStar.js
// module id = 90
// module chunks = 19843951674672 191949427803761 213534597649335